<template>
    <div class="slidecount-options">
        <p class="slidecount-options__label">
            {{label}}:
        </p>

        <ul class="slidecount-options__options">
            <li
                v-bind:key="option.value"
                v-for="option in slidecountoptions">
                <a v-if="!option.isCurrent"
                   v-bind:href="option.url">{{option.value}}</a>
                <span v-if="option.isCurrent">{{option.value}}</span>
            </li>
        </ul>
    </div>
</template>

<script>
    import { computed, createApp } from 'vue';

    const params = new window.URLSearchParams(window.location.search);

    export default {
        props : {
            default : Number,
            label : String,
            options : Array,
            urlarg : String
        },

        setup(props) {
            const current = computed(() => {
                return params.get(this.urlarg) ? parseInt(params.get(this.urlarg)) : this.default;
            });

            const slidecountoptions = computed(() => {
                return props.options.map((value) => {
                    return {
                        isCurrent : this.current === value,
                        url : getUrlWithArgument(value),
                        value : value
                    }
                });
            });

            function getUrlWithArgument(value) {
                // We take the current query and try to change the number of
                // images in the grid
                const loc = window.location;

                // We delete the page number because it might lead to weird
                // results, e.g. if you go from 12 to 144 slides, the page number
                // might not be in range and return a 'No results found'
                // error
                params.delete('pagenr');

                // Set the actual number of posts per page
                params.set(props.urlarg, value);

                return `${loc.origin}${loc.pathname}?${params.toString()}`;
            }

            return { current, slidecountoptions };
        }
    };
</script>